import React, { useEffect, useState } from 'react'
import './App.css'
import { Redirect, useHistory } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import ClipLoader from 'react-spinners/ClipLoader'
import { BiMenu } from 'react-icons/bi'
import SideNav from './layouts/SideNav'
import Header from './layouts/Header'
import SideNavCust from './layouts/SideNavCust'
import SideNavAff from './layouts/SideNavAff'
import { API_URL } from './config'

const FeedbackPage = () => {
  const history = useHistory()

  const [successError, setSuccessError] = useState('')
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [error, setError] = useState('')
  const [feedback, setFeedback] = useState('')
  const [loading, setLoading] = useState(false)
  const [subBtn, setSubtn] = useState('feedback-submit-disabled')
  const [disabled, setDisabled] = useState(true)
  const [context, setContext] = useState('')

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)
  const [collapsed, setCollapsed] = useState(window.innerWidth <= 768)

  const accounttype = localStorage.getItem('accounttype')

  let accountname = ''

  if (localStorage.getItem('customername') !== null) {
    accountname = localStorage.getItem('customername')
  } else if (localStorage.getItem('businessname') !== null) {
    accountname = localStorage.getItem('businessname')
  } else if (localStorage.getItem('partnername') !== null) {
    accountname = localStorage.getItem('partnername')
  }

  /*
   * ---------------------------------------------------------
   * Page setup
   * ---------------------------------------------------------
   */

  useEffect(() => {
    document.title = `${accountname || 'Karamale'} - Feedback`

    const updateIsMobile = () => {
      const mobile = window.innerWidth <= 768

      setIsMobile(mobile)

      if (mobile) {
        setCollapsed(true)
      }
    }

    updateIsMobile()

    window.addEventListener('resize', updateIsMobile)

    return () => {
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [accountname])

  /*
   * ---------------------------------------------------------
   * Sidebar
   * ---------------------------------------------------------
   */

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  /*
   * ---------------------------------------------------------
   * Feedback
   * ---------------------------------------------------------
   */

  const handleFeedback = (event) => {
    const value = event.target.value

    setFeedback(value)

    if (value.trim().length > 0 && context !== '') {
      setDisabled(false)
      setSubtn('feedback-submit')
    } else {
      setDisabled(true)
      setSubtn('feedback-submit-disabled')
    }

    setErrorDisplay('none')
  }

  const handleContext = (event) => {
    const value = event.target.value

    setContext(value)

    if (feedback.trim().length > 0 && value !== '') {
      setDisabled(false)
      setSubtn('feedback-submit')
    } else {
      setDisabled(true)
      setSubtn('feedback-submit-disabled')
    }

    setErrorDisplay('none')
  }

  /*
   * ---------------------------------------------------------
   * Submit
   * ---------------------------------------------------------
   */

  const update = () => {
    if (!feedback.trim() || !context) {
      return
    }

    setLoading(true)
    setSubtn('feedback-submit-disabled')
    setDisabled(true)

    const baseURL = `${API_URL}/apps/kscanner/webservices.php`

    const data = new FormData()

    data.append('feedback', feedback.trim())
    data.append('context', context)
    data.append('query', 'FEEDBACK')

    Axios({
      method: 'POST',
      url: baseURL,
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        let addClass = ''

        if (response.data.status === 'failed') {
          addClass = 'feedback-message-error'
        } else {
          addClass = 'feedback-message-success'
        }

        setError(response.data.message)
        setErrorDisplay('block')
        setSuccessError(addClass)

        setLoading(false)
        setSubtn('feedback-submit-disabled')
        setDisabled(true)

        if (response.data.status !== 'failed') {
          setFeedback('')
          setContext('')
        } else {
          setSubtn('feedback-submit')
          setDisabled(false)
        }

        setTimeout(() => {
          setErrorDisplay('none')
        }, 5000)
      })
      .catch((err) => {
        console.log(err)

        setError('Unable to submit your feedback. Please try again.')
        setErrorDisplay('block')
        setSuccessError('feedback-message-error')

        setLoading(false)
        setSubtn('feedback-submit')
        setDisabled(false)

        setTimeout(() => {
          setErrorDisplay('none')
        }, 5000)
      })
  }

  /*
   * ---------------------------------------------------------
   * Login validation
   * ---------------------------------------------------------
   *
   * IMPORTANT:
   * This comes AFTER all hooks.
   */

  if (
    localStorage.getItem('customername') === null &&
    localStorage.getItem('businessname') === null &&
    localStorage.getItem('partnername') === null
  ) {
    return <Redirect to="/login" />
  }

  /*
   * ---------------------------------------------------------
   * Render
   * ---------------------------------------------------------
   */

  return (
    <div className="view feedback-page">
      <Header />

      {accounttype === 'customer' ? (
        <SideNavCust collapsed={collapsed} onToggle={handleToggle} />
      ) : accounttype === 'business' ? (
        <SideNav collapsed={collapsed} onToggle={handleToggle} />
      ) : (
        <SideNavAff collapsed={collapsed} onToggle={handleToggle} />
      )}

      {/* Mobile overlay */}
      {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

      {/* Mobile menu */}
      {isMobile && collapsed && (
        <button
          type="button"
          className="mobile-toggle feedback-mobile-toggle"
          onClick={handleToggle}
          aria-label="Open menu"
        >
          <BiMenu size={25} />
        </button>
      )}

      {/* Main content */}
      <main
        className="feedback-content"
        style={{
          marginTop: 'var(--header-h)',
          marginLeft: isMobile ? 0 : collapsed ? '76px' : '252px',
        }}
      >
        <div className="feedback-container">
          {/* Back */}
          <button type="button" onClick={() => history.goBack()} className="feedback-back">
            <IoIosArrowBack size={22} />
            <span>Back</span>
          </button>

          {/* Intro */}
          <section className="feedback-intro">
            <div className="feedback-kicker">KARAMALE</div>

            <h1>Your experience matters.</h1>

            <p>
              Help us make Karamale better. Whether you're an organiser, attendee, KScanner
              operator, or partner, your feedback helps us improve the platform and the event
              experience.
            </p>
          </section>

          {/* Feedback card */}
          <section className="feedback-card">
            <div className="feedback-card-top">
              <div>
                <h2>Share your feedback</h2>

                <p>Tell us what you think. We read every submission.</p>
              </div>

              <div className="feedback-card-icon">✦</div>
            </div>

            <div className="feedback-line" />

            {/* Role */}
            <div className="feedback-field">
              <label htmlFor="feedback-role">What best describes your role?</label>

              <select
                id="feedback-role"
                value={context}
                onChange={handleContext}
                className="feedback-select"
              >
                <option value="">Select your role</option>

                {accounttype === 'business' && (
                  <>
                    <option value="organiser">Event Organiser</option>

                    <option value="scanner_operator">KScanner Operator</option>
                  </>
                )}

                {accounttype === 'customer' && (
                  <option value="ticket_buyer">Ticket Buyer / Attendee</option>
                )}

                {accounttype === 'partner' && <option value="partner">Partner / Affiliate</option>}
              </select>
            </div>

            {/* Feedback */}
            <div className="feedback-field">
              <div className="feedback-label-row">
                <label htmlFor="feedback-text">Your feedback or testimonial</label>

                <span>{feedback.length}/2000</span>
              </div>

              <textarea
                id="feedback-text"
                value={feedback}
                placeholder="Tell us about your experience with Karamale..."
                onChange={handleFeedback}
                className="feedback-textarea"
                rows={9}
                maxLength={2000}
              />

              <p className="feedback-hint">
                You can tell us what you enjoyed, what could be improved, or share a testimonial
                about your experience.
              </p>
            </div>

            {/* Submit */}
            <div className="feedback-footer">
              <button type="button" disabled={disabled} className={subBtn} onClick={update}>
                {loading ? (
                  <>
                    <ClipLoader color="#ffffff" loading={true} size={18} />

                    <span>Submitting...</span>
                  </>
                ) : (
                  'Submit Feedback'
                )}
              </button>
            </div>
          </section>

          {/* Result message */}
          <div
            className={successError}
            style={{
              display: errorDisplay,
            }}
          >
            <span className="feedback-message-icon">
              {successError === 'feedback-message-success' ? '✓' : '!'}
            </span>

            <span>{error}</span>
          </div>
        </div>
      </main>
    </div>
  )
}

export default FeedbackPage
